export default (Vue) => {
    /**
     * append to body , fixed positioned dom Better in a non-rolling container ,  You can use this command to move to body middle 
     * eg: v-appendToBody="{enable: true, cls: 'xxxx', placeHolder: true}"
     * enable  Indicates whether to enable appendToBody
     * cls  Indicates that when enabled, append to the current dom of class
     * placeHolder  Indicates when enabled , Do you need to be in the current dom Create a div for standing 
     */
    Vue.directive('appendToBody', {
        bind(el, binding, vnode) {
            if (!binding.value || binding.value.enable) {
                vnode.context.$nextTick(() => {
                    if (binding.value) {
                        //  fill a placeholder div
                        if (binding.value.placeHolder) {
                            var holder = document.createElement('div');
                            holder.style.height = `${el.clientHeight}px`;
                            el.after(holder);
                            el.holder = holder;
                        }
                        //  Add to class
                        if (binding.value.cls) {
                            binding.value.cls
                                .split(' ')
                                .forEach((c) => el.classList.add(c));
                        }
                    }
                    window && window.document.body.appendChild(el);
                });
            }
        },
        unbind(el, binding) {
            if (!binding.value || binding.value.enable) {
                if (el.holder) {
                    el.holder.parentNode.removeChild(el.holder);
                }
                window && window.document.body.removeChild(el);
            }
        }
    });
};
